import { createReducer, on } from '@ngrx/store';
import * as  SupplierActions from '../../actions/master-data/supplier.actions';
import { SupplierState } from '../../states/master-data/supplier.state';

export const initialState: SupplierState = {loading: false, suppliers: [], succssMessage: '', error: null};

export const supplierReducer = createReducer(
    initialState,
    on(SupplierActions.loadSuppliers, (state) => ({ ...state, loading: true, error: null, succssMessage: '' })),
    on(SupplierActions.loadSuppliersSuccess, (state, {suppliers}) => ({ ...state, loading: false, suppliers })),
    on(SupplierActions.addSupplier, (state, {supplier}) => ({...state, suppliers: [...state.suppliers, supplier]})),
    on(SupplierActions.addSupplierSuccess, (state, {message}) => ({...state, succssMessage: message, error: null})),
    on(SupplierActions.updateSupplier, (state, {supplier}) => ({...state, supplier: state.suppliers.map((r: { id: number; }) => r.id === supplier.id ? supplier : r)})),
    on(SupplierActions.updateSupplierSuccess, (state, {message}) => ({...state, succssMessage: message, error: null})),
    on(SupplierActions.deleteSupplier, (state, {id}) => ({...state, suppliers: state.suppliers.filter((r: { id: number; }) => r.id !== id)})),
    on(SupplierActions.deleteSupplierSuccess, (state, {message}) => ({...state, succssMessage: message, error: null})),
    on(SupplierActions.loadSupplierFailure, (state, {error}) => ({ ...state, loading: false, error })),
);